<template>
  <div>
    <div class="outgoing-detail" v-if="detail != null">
      <Toast />

      <div class="card">
        <h5 style="text-align: center">
          <b>Bon Order Barang</b>
        </h5>
        <div class="p-grid">
          <div class="p-col-2">
            <div>KODE MUTASI</div>
          </div>
          <div class="p-col-10">
            <div>: {{ detail.summary.doc_number }}</div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-2">
            <div>SUPPLIER</div>
          </div>
          <div class="p-col-10">
            <div>
              : {{ detail.summary.supplier_code }}/{{
                detail.summary.supplier_name
              }}
            </div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-2">
            <div>TANGGAL BON</div>
          </div>
          <div class="p-col-10">
            <div>
              : {{ moment(detail.summary.doc_date).format('DD-MM-YYYY') }}
            </div>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-2">
            <div>TANGGAL MUTASI</div>
          </div>
          <div class="p-col-10">
            <div>: {{ moment(new Date()).format('DD-MM-YYYY') }}</div>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12">
            <table class="table table-responsive table-bordered">
              <thead class="thead-light">
                <tr>
                  <th>No</th>
                  <th>Kode Label</th>
                  <th>Nama</th>
                  <th>Qty</th>
                  <th v-for="(an_item, k) in listOutlets" :key="k">
                    {{ an_item.code }}
                  </th>
                  <th>HM (Rp)</th>
                  <th>Harga Jual</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(an_item, k) in detail.purchase_orders" :key="k">
                  <td>{{ k + 1 }}</td>
                  <td>{{ an_item.item_code }}</td>
                  <td>{{ an_item.item_name }}</td>
                  <td>{{ an_item.qty }}</td>
                  <td v-for="(an_item, k) in listOutlets" :key="k"></td>
                  <td>{{ calculateHM(an_item.qty, an_item.price) }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require('moment')
export default {
  props: ['detail', 'listOutlets'],
  data() {
    return {
      moment: moment,
      loading: true,
      products: null,
      expandedRows: [],
      confirmDialog: false,
      outlets: [
        {
          id: 1,
          code: 'Z001',
          name: 'Outlet Mall',
          status: 1,
          address: 'address',
          phone: 'phone'
        },
        {
          id: 2,
          code: 'Z002',
          name: 'Outlet Mall',
          status: 1,
          address: 'address',
          phone: 'phone'
        }
      ]
    }
  },
  mounted() {
    setTimeout(function () {
      window.print()
    }, 500)
    setTimeout(function () {
      window.history.back()
    }, 500)
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    calculateHM(qty, price) {
      let temp = parseFloat(price) / qty
      return this.formatPrice(temp)
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;
  .p-progressbar-value {
    background-color: #607d8b;
  }
}
.p-datatable .p-column-filter {
  display: none;
}
.table-header {
  display: flex;
  justify-content: space-between;
}
/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }
  .p-paginator {
    padding: 1rem;
  }
  .p-datatable-thead > tr > th {
    text-align: left;
  }
  .p-datatable-tbody > tr > td {
    cursor: auto;
  }
  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}
/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }
  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }
  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }
  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }
  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }
  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}
.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}
@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}
.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.orders-subtable {
  padding: 1rem;
}
.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }
  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }
  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}
input:disabled {
  color: black;
}
.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }
  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }
  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }
  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}
@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }
      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }
          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
